import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VendorVerify() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/vendor/verify/${token}`)
      .then((res) => {
        if (!alive) return;
        setState("success");
        setMessage(res.data.message || "Email verified successfully");
      })
      .catch((err) => {
        if (!alive) return;
        setState("error");
        setMessage(err.response?.data?.detail || "Verification link is invalid or has expired");
      });
    return () => { alive = false; };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F3FA] px-4" data-testid="vendor-verify-page">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
        {state === "loading" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-[#2D2766] animate-spin" />
            <p className="mt-4 text-gray-600">Verifying your email…</p>
          </>
        )}
        {state === "success" && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-green-100 flex items-center justify-center">
              <CheckCircle2 className="w-9 h-9 text-green-600" />
            </div>
            <h1 className="mt-4 text-2xl font-bold text-gray-900">Email Verified!</h1>
            <p className="mt-2 text-gray-600 text-sm">{message}</p>
            <button
              onClick={() => navigate("/vendor")}
              className="mt-6 w-full py-3 rounded-xl text-white font-semibold"
              style={{ backgroundColor: "#2D2766" }}
              data-testid="verify-go-dashboard"
            >
              Go to Vendor Dashboard
            </button>
          </>
        )}
        {state === "error" && (
          <>
            <div className="w-16 h-16 mx-auto rounded-full bg-red-100 flex items-center justify-center">
              <XCircle className="w-9 h-9 text-red-600" />
            </div>
            <h1 className="mt-4 text-2xl font-bold text-gray-900">Verification Failed</h1>
            <p className="mt-2 text-gray-600 text-sm">{message}</p>
            <button
              onClick={() => navigate("/vendor")}
              className="mt-6 w-full py-3 rounded-xl text-white font-semibold"
              style={{ backgroundColor: "#2D2766" }}
              data-testid="verify-try-again"
            >
              Go to Vendor Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
